<section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar> 
  </div>
  <div class="right-panel">

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <h4 class="pageTitle"> Work Experience</h4>
          <div class="row">
              <div class="col-md-6 col-lg-6 ">
                  <div class="form-group">
                      <label>Job title<span class="orangeText">*</span> </label>
                      <input  type="text" name="" class="form-control upper" placeholder="Enter a Job title" formControlName="jobTitle" maxLength="50">
                      <div class="text-danger" *ngIf="form.controls['jobTitle'].hasError('required') && showError">
                        *Please enter Job title.
                    </div>
                    <div class="text-danger" *ngIf="form.controls['jobTitle'].hasError('maxLength') && showError">
                      *Maximum length of 50 characters.
                   </div>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6 ">
                  <div class="form-group">
                      <label> Company<span class="orangeText">*</span> </label>
                      <input  type="text" name="" class="form-control upper" placeholder="Enter Company" formControlName="companyName" maxLength="50">
                      <div class="text-danger" *ngIf="form.controls['companyName'].hasError('required') && showError">
                        *Please enter company name.
                    </div>
                    <div class="text-danger" *ngIf="form.controls['companyName'].hasError('maxlength') && showError">
                      *Maximum length of 50 characters.
                   </div>
                  </div>
              </div>
              <div class="col-md-12 col-lg-12 col-sm-12 ">     
                <h5 class="subTitle2"> Employment type </h5>
                <div class="form-group">
                    <ul class="suggestedskills">
                        <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmployment(i,$event)" [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li> 
                    </ul>
                    <!-- <div class="text-danger" *ngIf="form.controls['employementTypeId'].hasError('required') && showError">
                        *Please Select Employment type.
                    </div> -->
                </div>
              </div> 
              <div class="col-md-6 col-lg-6 col-sm-12" *ngIf="showContract">
                  <div class="form-group">
                      <label> Under contract of</label>
                      <input type="text" name="" class="form-control upper" placeholder="Infosys" formControlName="underContractOf">
                      <div class="text-danger" *ngIf="form.controls['underContractOf'].hasError('required') && showError">
                          *Please Select Employment type.
                      </div>
                  </div>
              </div>

              <div class="col-md-6 col-lg-6 col-sm-12 ">
                  <div class="form-group upperLetter">
                      <label> Location</label>
                      <input type="text" name="" class="form-control upper" placeholder="Enter location"  formControlName="location">
                      <div class="text-danger" *ngIf="form.controls['location'].hasError('required') && showError">
                          *Please enter location.
                      </div>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6  col-sm-12">
                  <div class="form-group">
                      <label> Description </label>
                      <textarea type="text" class="form-control" placeholder="As a team lead, a UX manager sets design standards for the team and trains and supports the team in UX best practices." formControlName="description" maxlength="250"></textarea>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                          *Please enter description.
                      </div>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('minlength') && showError">
                          *Minimum length of 3 characters.
                      </div>
                      <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                          *Minimum length of 250 characters.
                      </div>
                  </div>
              </div>


              <div class="col-md-6 col-lg-6 col-sm-12 ">
                  <div class=" d-flex justify-content-between">
                      <div class="form-group">
                          <label> From <span class="orangeText">*</span></label>
                          <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" bsDatepicker placement="bottom" [bsValue]="form.value.fromDate" [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="fromDate" [maxDate]="maxDate" (keydown)="onKeyDown($event)">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && form.controls['fromDate'].hasError('required')">*Please select From</div>
                      </div>

                      <div class="form-group">
                          <label> To <span class="orangeText">*</span></label>
                          <div id="date-picker-example" class="datepicker">
                            <input type="text" placeholder="Enter date"
                            class="form-control" bsDatepicker
                            [minDate]="form.value.fromDate == '' ? minDate : form.value.fromDate"
                            formControlName="toDate"
                            [bsValue]="form.value.toDate" [maxDate]="maxDate"
                            [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" (keydown)="onKeyDown($event)">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger" *ngIf="showError == true && form.controls['toDate'].hasError('required')">*Please select To</div>
                      </div>
                  </div>
              </div>
              <div class="col-md-12 col-lg-12 col-sm-12">
                  <div class="form-group pt-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isCurrentlyRole" [value]="1" [checked]="form.value.isCurrentlyRole == 1" (change)="form.value.isCurrentlyRole=1;isDisabled($event)">
                          <label class="custom-control-label" for="customCheckBox1"> I am currently working in this role</label>
                          <div class="text-danger" *ngIf="form.controls['isCurrentlyRole'].hasError('required') && showError">
                              *Please accept select.
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="form-group ">
            <input type="submit" value="Save"  class="commonBtn width50 mt-4"> 
          </div>

      </form>
  </div>
</section>